import * as React from "react";
import { useIsExpressPaymentMethodSupported } from "./use-is-express-payment-method-supported.js";
import { PaymentMethod } from "../../models/cart-payment-methods/models/cart-payment-methods/cart-payment-methods.js";
const useIsGooglePaySupportedForCart = (cartId) => {
  const [
    getIsGooglePaySupportedForCart,
    { isPaymentMethodSupported, called, loading, error, paymentConfiguration }
  ] = useIsExpressPaymentMethodSupported(PaymentMethod.GOOGLE_PAY);
  React.useEffect(() => {
    if (cartId) {
      getIsGooglePaySupportedForCart(cartId);
    }
  }, [cartId]);
  return {
    isGooglePaySupportedForCart: isPaymentMethodSupported,
    paymentConfiguration,
    loading,
    called,
    error
  };
};
export {
  useIsGooglePaySupportedForCart
};
//# sourceMappingURL=use-is-google-pay-supported-for-cart.js.map
